import { useNavigate } from "react-router-dom";
import { formatDate } from "../../util";
import { roundPriorityScore } from "../../util";
import BooleanDisplay, {True, False} from "../misc/BooleanDisplay.jsx";


const PatientTable = ({ data, sortBy, sortOrder, onSort, isSorted }) => {

    const navigate = useNavigate();

    const showDetails = (operationId) => {
        navigate(`/operation/${operationId}`);
        };       
        
  // Headers for the data. Convention entails key to be first, not the label (attached)
  const columns = [
        { key: "surgeonId", header: "Surgeon ID",
        render: (item) => (item.surgeonId || "N/A")
        },
        { key: "chId", header: "Patient ID" },
        { key: "age", header: "Age" },

        // Mapping numerical values of the operation type, to qualitative values to be represented
        { key: "operationType", header: "Operation Type",
        render: (item) => {
            if (item.operationType === 0) return "Hip Replacement";
            if (item.operationType === 1) return "Knee Replacement";
        }, 
        },

        { key: "surgerySide", header: "Surgery Side",
        render: (item) => {
            if (item.surgerySide === "L") return "Left";
            if (item.surgerySide === "R") return "Right";
        }, 
        },

        { key: "preassessmentPassed", header: "Preassessment Status",
        render: (item) => (item.preassessmentPassed ? "Passed" : "Failed" || "N/A")
        },

        // Formatting to a more user-friendly way
        { key: "theatreDate", header: "Provisional Theatre Date", 
        render: (item) => formatDate(item.theatreDate)
        },

        // These are the ones with boolean values. In essence, true or false. 
        { key: "bedRequired", header: "HDU/ITU Bed Requirement",
        render: (item) => (<BooleanDisplay value={item?.bedRequired} />)
        },
        { key: "ntcSuitability", header: "NTC Suitability", 
        render: (item) => (<BooleanDisplay value={item?.ntcSuitability} />)
        },
        { key: "roboticSurgery", header: "Robotic Surgery", 
        render: (item) => (<BooleanDisplay value={item?.roboticSurgery} />)
        },

        // The priority score has to be rounded, as per the client's request. It uses a dedicated function, and renders it 
        // as a real number, if the priority score is not there. 
        
        { key: "priorityScore", header: "Priority Score",
        align: "right", cellStyle: {fontWeight: "bold"}, 
        render: (item) => roundPriorityScore(item.priorityScore)  || "ℝ.xyz"
        },
    ];

    return (
        <table className="patient-table">
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th 
                            key={column.key}
                            style={{ 
                                textAlign: column.align || 'left', 
                                cursor: 'pointer',
                                ...column.headerStyle 
                            }}
                            onClick={() => onSort(column.key)}
                        > 
                            {column.header} 
                            {isSorted && sortBy === column.key && (
                                <span> {sortOrder === "asc" ? "▲" : "▼"} </span>
                            )}
                        </th>
                    ))}
                </tr>
            </thead>

            <tbody>
                {data && data.length > 0 ? (
                    data.map((operation) => (
                        <tr 
                            className="clickable-row" 
                            onClick={() => showDetails(operation._id)} 
                            key={`${operation._id}`}
                        >
                            {columns.map((column) => (
                                <td 
                                    key={column.key}
                                    style={{ 
                                        textAlign: column.align || 'left', 
                                        ...column.cellStyle 
                                    }}
                                >
                                    {column.render ? column.render(operation) : operation[column.key]}
                                </td>
                            ))}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={columns.length} style={{ textAlign: 'center' }}>
                            No data available
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default PatientTable;